import {
  coins_units,
  units,
  units_1,
  units_2,
  units_3,
  units_4,
  units_5,
  units_6,
  units_7,
} from "../constants.js";

// import {
//     convertUnits
//   } from "./convert.js";

//Codigos que se ven en los formularios
export const productionCodes = {
  production_volume: "VP1",
  standardized_production:"VPS",
  billing_volume: "VF1",
  standardized_billing:"VFS"
};

//Codigos de los indicadores que se ven en el dashboard
export const energyKPIsCodes = {
  electricity_standard_kpis: "KPIener1",
  renewable_energies_kpis: "KPIener2",
  steam_kpis: "KPIener3",
  natural_gas_kpis: "KPIener4",
  glp_kpis: "KPIener5",
  heavy_fuel_oil_kpis: "KPIener6",
  light_fuel_oil_kpis: "KPIener7",
  coal_kpis: "KPIener8",
  diesel_kpis: "KPIener9",
  biodiesel_kpis: "KPIener10",
  gasoline_kpis: "KPIener11",
  biomass_kpis: "KPIener12",
  total_energy_kpis: "KPIener13",
  electricity_cost_kpis: "KPIener14",
  renewable_energy_cost_kpis: "KPIener15",
  steam_cost_kpis: "KPIener16",
  natural_gas_cost_kpis: "KPIener17",
  glp_cost_kpis: "KPIener18",
  cost_of_heavy_fuel_oil_kpis: "KPIener19",
  cost_of_light_fuel_oil_kpis: "KPIener20",
  coal_cost_kpis: "KPIener21",
  diesel_cost_kpis: "KPIener22",
  cost_biodiesel_kpis: "KPIener23",
  gasoline_cost_kpis: "KPIener24",
  biomass_cost_kpis: "KPIener25",
  total_energy_cost_kpis: "KPIener26",
  electricity_standard_unit_kpis: "KPIener27",
  renewable_energies_unit_kpis: "KPIener28",
  steam_unit_kpis: "KPIener29",
  natural_gas_unit_kpis: "KPIener30",
  glp_unit_kpis: "KPIener31",
  heavy_fuel_oil_unit_kpis: "KPIener32",
  light_fuel_oil_unit_kpis: "KPIener33",
  coal_unit_kpis: "KPIener34",
  diesel_unit_kpis: "KPIener35",
  biodiesel_unit_kpis: "KPIener36",
  gasoline_unit_kpis: "KPIener37",
  biomass_unit_kpis: "KPIener38",
  total_energy_unit_kpis: "KPIener39",
  electrical_energy_cost_unit_kpis: "KPIener40",
  renewable_energy_percentage_kpis: "KPIener41",
  non_renewable_energy_percentage: "KPIener42",
};


//En base al valor del campo / key devuelve el valor correspondiente de acuerdo al año es de tipo {total, unit}
// export function energyFormulasIndicators(field, year, data) {
//   switch (field) {
//     case "electricity_standard_kpis":
//       //data["electricity_standard"]?.[year] || { total: 0, unit: "" }; 
//       //esto devuelve si hay valor cargado para el campo electricity_standard si es asi devuelve el valor del año sino envio { total: 0, unit: "" }; 
//       return data["electricity_standard"]?.[year] || { total: 0, unit: "" };
//     case "renewable_energies_kpis":
//       return data["renewable_energies"]?.[year] || { total: 0, unit: "" };
//     case "steam_kpis":
//       return data["steam"]?.[year] || { total: 0, unit: "" };
//     case "natural_gas_kpis":
//       return data["natural_gas"]?.[year] || { total: 0, unit: "" };
//     case "glp_kpis":
//       return data["glp"]?.[year] || { total: 0, unit: "" };
//     case "heavy_fuel_oil_kpis":
//       return data["heavy_fuel_oil"]?.[year] || { total: 0, unit: "" };
//     case "light_fuel_oil_kpis":
//       return data["light_fuel_oil"]?.[year] || { total: 0, unit: "" };
//     case "coal_kpis":
//       return data["coal"]?.[year] || { total: 0, unit: "" };
//     case "diesel_kpis":
//       return data["diesel"]?.[year] || { total: 0, unit: "" };
//     case "biodiesel_kpis":
//       return data["biodiesel"]?.[year] || { total: 0, unit: "" };
//     case "gasoline_kpis":
//       return (
//         data["gasoline_for_internal_vehicles"]?.[year] || { total: 0, unit: "" }
//       );
//     case "biomass_kpis":
//       return data["biomass"]?.[year] || { total: 0, unit: "" };
//     case "total_energy_kpis":
//       //Aca en el array estan los campos que debe sumar y luego llamo a la funcion 
//       //addData() le paso los campos, el año, la data y como valor predeterminado la unidad de conversion para que sean todas iguales (REVISAR DESPUES IGUAL) 
//       let keys = [
//         "electricity_standard",
//         "renewable_energies",
//         "steam",
//         "natural_gas",
//         "glp",
//         "heavy_fuel_oil",
//         "light_fuel_oil",
//         "coal",
//         "diesel",
//         "biodiesel",
//         "gasoline",
//         "biomass",
//       ];
//       return {
//         total: addData(keys, year, data, "kWh"),
//         unit: "kWh",
//       };
//     case "electricity_cost_kpis":
//       return data["electricity_cost"]?.[year] || { total: 0, unit: "" };
//     case "renewable_energy_cost_kpis":
//       return data["renewable_energy_cost"]?.[year] || { total: 0, unit: "" };
//     case "steam_cost_kpis":
//       return data["steam_cost"][year] || { total: 0, unit: "" };
//     case "natural_gas_cost_kpis":
//       return data["natural_gas_cost"]?.[year] || { total: 0, unit: "" };
//     case "glp_cost_kpis":
//       return data["glp_cost_kpis"]?.[year] || { total: 0, unit: "" };
//     case "cost_of_heavy_fuel_oil_kpis":
//       return data["cost_of_heavy_fuel_oil"]?.[year] || { total: 0, unit: "" };
//     case "cost_of_light_fuel_oil_kpis":
//       return (
//         data["cost_of_light_fuel_oil"]?.[year] || { total: 0, unit: "" }
//       );
//     case "coal_cost_kpis":
//       return data["coal_cost"]?.[year] || { total: 0, unit: "" };
//     case "diesel_cost_kpis":
//       return data["diesel_cost"]?.[year] || { total: 0, unit: "" };
//     case "cost_biodiesel_kpis":
//       return data["cost_biodiesel"]?.[year] || { total: 0, unit: "" };
//     case "gasoline_cost_kpis":
//       return data["gasoline_cost"]?.[year] || { total: 0, unit: "" };
//     case "biomass_cost_kpis":
//       return data["gasoline_cost"]?.[year] || { total: 0, unit: "" };
//     case "total_energy_cost_kpis":
//       let keys1 = [
//         "electricity_cost",
//         "renewable_energies_cost",
//         "steam_cost",
//         "natural_gas_cost",
//         "glp_cost",
//         "cost_of_heavy_fuel_oil",
//         "cost_of_light_fuel_oil",
//         "coal_cost",
//         "diesel_cost",
//         "cost_biodiesel",
//         "gasoline_cost",
//         "cost_biomass_cost",
//       ];
//       return {
//         total: addData(keys1, year, data, "Dólar estadounidense (USD)"),
//         unit: data["electricity_cost"][year].unit,
//       };
//     case "electricity_standard_unit_kpis":
//        //En este caso despues vemos de donde provienen los valores VPS o VFS momentaneamente manejamos asi los datos despues modificamos
//        let den = 1; ///falta saber de donde tomar VPS o VFS
//        let result = data["electricity_standard"]?.[year].total  / den;
//        return {total:result,unit:""};
//     case "renewable_energies_unit_kpis":
//         let den1 = 1; ///falta saber de donde tomar VPS o VFS
//         let result2 = data["renewable_energies"]?.[year].total  / den1;
//        return {total:result2,unit:""};       
//     case "steam_unit_kpis":
//         let den3 = 1; ///falta saber de donde tomar VPS o VFS
//         let result3 = data["steam"]?.[year].total  / den3;
//        return {total:result3,unit:""}; 
//     case "natural_gas_unit_kpis":
//         let den4 = 1; ///falta saber de donde tomar VPS o VFS
//         let result4 = data["natural_gas"]?.[year].total  / den4;
//        return {total:result4,unit:""}; 
//     case "glp_unit_kpis":
//         let den5 = 1; ///falta saber de donde tomar VPS o VFS
//         let result5 = data["glp"]?.[year].total  / den5;
//        return {total:result5,unit:""};     
//     case "heavy_fuel_oil_unit_kpis":
//         let den6 = 1; ///falta saber de donde tomar VPS o VFS
//         let result6 = data["heavy_fuel_oil"]?.[year].total  / den6;
//        return {total:result6,unit:""};    
//     case "light_fuel_oil_unit_kpis":
//         let den7 = 1; ///falta saber de donde tomar VPS o VFS
//         let result7 = data["light_fuel_oil"]?.[year].total  / den7;
//        return {total:result7,unit:""};     
//     case "coal_unit_kpis":
//         let den8 = 1; ///falta saber de donde tomar VPS o VFS
//         let result8 = data["coal"]?.[year].total / den8;
//        return {total:result8,unit:""};     
//     case "diesel_unit_kpis":
//         let den9 = 1; ///falta saber de donde tomar VPS o VFS
//         let result9 = data["diesel"]?.[year].total  / den9;
//        return {total:result9,unit:""};       
//     case "biodiesel_unit_kpis":
//         let den10 = 1; ///falta saber de donde tomar VPS o VFS
//         let result10 = data["biodiesel"]?.[year].total  / den10;
//        return {total:result10,unit:""};      
//     case "gasoline_unit_kpis":
//         let den11 = 1; ///falta saber de donde tomar VPS o VFS
//         let result11 = data["gasoline"]?.[year].total  / den11;
//         return result11;
//     case "biomass_unit_kpis":
//         const result_biomass=data["biomass"]?.[year].total / 1;
//         return {total:result_biomass ,unit:""}|| { total: 0, unit: "" };
//     case "total_energy_unit_kpis":
//         let keys2 = [
//             "electricity_cost",
//             "renewable_energies_cost",
//             "steam_cost",
//             "natural_gas_cost",
//             "glp_cost",
//             "cost_of_heavy_fuel_oil",
//             "cost_of_light_fuel_oil",
//             "coal_cost",
//             "diesel_cost",
//             "cost_biodiesel",
//             "gasoline_cost",
//           ];
//           return {
//             total: addData(keys2, year, data, "Dólar estadounidense (USD)"),
//             unit: data["electricity_cost"][year].unit,
//           };
//     case "electrical_energy_cost_unit_kpis":
//         const result_electrical_energy=data["total_energy_cost_kpis"]?.[year].total / 1;
//       return {total:result_electrical_energy ,unit:""}|| { total: 0, unit: "" };
//     case "renewable_energy_percentage_kpis":
//       const result1=data["electricity_standard"]?.[year].total * data["total_energy_kpis"]?.[year].total / 100;
//       return {total:result1 ,unit:""}|| { total: 0, unit: "" };
//     case "non_renewable_energy_percentage":
//       return {total:1 - data["renewable_energy_percentage_kpis"]?.[year].total ,unit:""}|| { total: 0, unit: "" };
//     default:
//       return false;
//   }
// }

// //Suma los valores de los campos/claves pasadas como parametros
// function addData(keys, year, data, unitSelected) {
//   let suma = 0;
//   //tomo como referencia el kwh
//   for (let clave of keys) {
//     if (data.hasOwnProperty(clave)) {
//       suma += convertUnits(data[clave]?.[year].total, data[clave]?.[year].unit, unitSelected) || 0;
//     }
//   }

//   return suma;
// }

//Determina las unidades utilizadas de acuerdo a cada campo/key ver boceto con unidades
export const determineEnergyUnits = (value) => {
  if (value === "electricity_standard" || value === "electricity_standard_kpis")
    return units;
  else if (
    value === "electricity_cost" ||
    //   value === "renewable_energies_produced_and_consumed_on_site" ||
    value === "steam_cost" ||
    // || value==="glp_cost"
    value === "cost_of_heavy_fuel_oil" ||
    value === "cost_of_light_fuel_oil" ||
    value === "coal_cost" ||
    value === "diesel_cost" ||
    value === "gasoline_cost_of_internal_vehicles" ||
    value === "biomass_cost" ||
    value === "electricity_cost_kpis" ||
    value === "steam_cost_kpis" ||
    // || value==="glp_cost"
    value === "cost_of_heavy_fuel_oil_kpis" ||
    value === "cost_of_light_fuel_oil_kpis" ||
    value === "coal_cost_kpis" ||
    value === "diesel_cost_kpis" ||
    value === "gasoline_cost_of_internal_vehicles_kpis" ||
    value === "biomass_cost_kpis" ||
    value === "total_energy_cost_kpis" ||
    value === "electricity_cost_kpis" ||
    value === "electrical_energy_cost_unit_kpis"
  ) {
    return coins_units;
  } else if (value === "renewable_energies" || value === "renewable_energies_kpis") {
    return units_1;
  } else if (
    value === "steam" ||
    value === "natural_gas" ||
    value === "diesel" ||
    value === "gasoline_for_internal_vehicles" ||
    value === "steam_kpis" ||
    value === "natural_gas_kpis" ||
    value === "diesel_kpis" ||
    value === "gasoline_kpis"
  )
    return units_2;
  else if (
    value === "gasoline_cost_of_internal_vehicles" ||
    value === "biomass" ||
    value === "natural_gas_cost" ||
    value === "gasoline_cost_kpis" ||
    value === "biomass_kpis" ||
    value === "natural_gas_cost_kpis"
  )
    return units_3;
  else if (value === "glp_cost" || value === "glp_cost_kpis") return units_4;
  else if (
    value === "cost_of_heavy_fuel_oil" ||
    value === "cost_of_heavy_fuel_oil_kpis"
  )
    return units_5;
  else if (
    value === "cost_of_light_fuel_oil" ||
    value === "cost_of_light_fuel_oil_kpis"
  )
    return units_6;
  else if (value === "coal" || value === "coal_kpis") return units_7;
  else {
    return units;
  }
};
